import axios from "axios";

// Create a dedicated Axios instance for the local API
const instance = axios.create({
	baseURL: "/",
	// timeout: 10000,
	headers: {
		Accept: "application/json, text/plain, */*",
		// "Content-Type": "application/x-www-form-urlencoded",
	},
});

// Optionally, you can add interceptors if needed (without modifying headers)
instance.interceptors.request.use(
	(config) => {
		return config;
	},
	(error) => Promise.reject(error),
);

instance.interceptors.response.use(
	(response) => response,
	(error) => {
		console.error("Local API Response Error:", error);
		return Promise.reject(error);
	},
);

export default instance;
